import { setUseFeature } from "@tuqqi/web"
import { setApplyTemplate } from "./useApplyTemplate"

export let useNewForms = true;

const setUseNewForms = (val) => {
    useNewForms = val
}

export const runFeatures = () => {
    setApplyTemplate(false)
    setUseNewForms(true)
    setUseFeature("withGroupTableExportLinkedLimit2000", true)
    setUseFeature("withTableGanttDeps", true)
    setUseFeature("withACInProgressGroupBy", false)
}